const chartColors = [
	"#005FB6",
	"#F765A3",
	"#A155B9",
	"#1DDD8D",
	"#FCA626",
	"",
];

export default chartColors;